import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuItem } from '../../../core/enums/menu.enum';
import { UserRole } from '../../../core/enums/user-role.enum';
import { WorkflowToken } from '../../../core/enums/workflow-token.enum';
import { CompanyType } from '../../../core/enums/company-types.enum';
import { User } from '../../../core/models/user.model';
import { MenuService } from '../../../core/services/menu.service';
import { SessionService } from '../../../core/services/session.service';
import { ConfigService } from '../../../core/services/config.service';

@Component({
	selector: 'cfe-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
	// User roles for authorization handling
	public userRole = UserRole;

	// Workflow tokens for authorization handling
	public workflowToken = WorkflowToken;

	// Current user
	public user: User;

	// Menu item
	public MenuItem = MenuItem;

	public companyType = CompanyType;

	// Subscriptions
	protected subscriptions: Subscription[] = [];

	/**
	 * Initialize services
	 *
	 * @param session
	 * @param menuService
	 * @param configService
	 */
	constructor(protected session: SessionService, private menuService: MenuService, private configService: ConfigService) {}

	/**
	 * On init handling
	 */
	ngOnInit() {
		// Init current user
		this.user = this.session.currentUser;

		// Subscribe user change
		this.subscriptions.push(
			this.session.currentUserObservable.subscribe((user) => {
				this.user = user;
			})
		);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy() {
		this.subscriptions.map((subscription) => {
			subscription.unsubscribe();
		});
	}

	/**
	 * Translate menu item
	 *
	 * @param menuItem
	 */
	translateMenu(menuItem: MenuItem) {
		return this.menuService.getByMenuItem(menuItem);
	}

	/**
	 * Disable access for user from China in global cloud.
	 * https://jira.dentsplysirona.com/browse/CCCPR-29
	 */
	isDisconnectedUser(): boolean {
		return this.user.hasRole(UserRole.DISCONNECTED_USER) && !this.configService.config.hostedInChinaCloud;
	}

	closeMenu() {
		this.menuService.menuState = false;
	}
}
